"use client"

import type { ReactNode } from "react"
import { topicForHref } from "@/lib/breach/panel-topics"
import { useInfoPanel } from "./info-panel"
import { NewTabLink } from "./new-tab-link"

/**
 * A link to a resource page. Inside the incident tool it opens the same content in a panel over the page,
 * so nobody has to leave their place; anywhere else (or for pages with no panel) it opens a new tab.
 */
export function ResourceLink({ href, className, children }: { href: string; className?: string; children: ReactNode }) {
  const panel = useInfoPanel()
  const hit = topicForHref(href)
  if (panel && hit) {
    return (
      <button type="button" className={className} aria-haspopup="dialog" onClick={() => panel.open(hit.topic, hit.anchor)}>
        {children}
      </button>
    )
  }
  return <NewTabLink href={href} className={className}>{children}</NewTabLink>
}
